import { ListSubheader, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const OptionGroup = styled(ListSubheader)(({ theme }) => ({
  lineHeight: '32px',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: '0.75rem',
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.action.hover,
}));

// MUI skips group labels during keyboard navigation only when the wrapper carries this marker.
(OptionGroup as typeof OptionGroup & { muiSkipListHighlight: boolean }).muiSkipListHighlight = true;

export const OptionItem = styled(MenuItem, {
  shouldForwardProp: prop => prop !== '$grouped',
})<{ $grouped: boolean }>(({ theme, $grouped }) => ({
  minHeight: '36px !important',
  ...($grouped && { paddingLeft: theme.spacing(3.5) }),
}));
